<template>
  <v-container tag="section" class="content detail">
    <v-row v-if="this.$auth.user().id">
      <v-col class="text-right">
        <v-btn :color="currentColor()" :to="{ name: 'frontend.my-family' }"  class="mr-0">
          {{ $t("my_family.menu_button") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <template v-if="$auth.user().people == null">
          <v-alert type="info">
            {{ $t("my_family.warning_alert_no_people") }}
          </v-alert>
        </template>
        <v-card class="mx-auto mt-0" color="white" max-width="100%" v-else>
          <v-progress-linear
            indeterminate
            rounded
            height="6"
            v-if="loading"
          ></v-progress-linear>
          <template v-else>
            <v-img
              class="white align-end"
              height="300px"
              :src="'/img/background.jpg'"
            >
            </v-img>
            <v-card-title>
              <h2 class="mb-3 mt-3">
                <v-avatar class="mr-2" :color="currentColor()">
                  <v-icon dark large>
                    mdi-cash-multiple
                  </v-icon>
                </v-avatar>
                {{ $t("payment_confirmation") }}
              </h2>
            </v-card-title>

            <v-card-text class="mt-3 pa-2">

              <template v-if="confirmations && confirmations.length">
                <v-divider></v-divider>

                <v-card color="grey lighten-2">
                  <v-card-text>
                    <h3 class="mb-5 mt-5">
                      <v-avatar color="indigo" size="30" class="mr-1 mb-1">
                        <span class="white--text text-">{{
                          confirmations ? confirmations.length : 0
                        }}</span>
                      </v-avatar>
                      {{ $t("payment_confirmation") }}
                    </h3>
                    <v-simple-table class="my-5 ml-3" light v-if="$vuetify.breakpoint.mdAndUp">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">
                              {{ $t("Name") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Kurs") }}
                            </th>
                            <th class="text-left">
                              {{ $t("Wochen") }}
                            </th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-if="confirmations && confirmations.length">
                          <tr
                            v-for="(confirmation, index) in confirmations"
                            :key="index"
                          >
                            <td>{{ confirmation.child_name }}</td>
                            <td>{{ confirmation.course_name }}</td>
                            <td>{{ confirmation.week_count }}</td>
                            <td>
                              <v-btn
                                small
                                rounded
                                target="_blank"
                                :href="
                                  '/confirmation/' +
                                    confirmation.courseId +
                                    '/' +
                                    confirmation.peopleId +
                                    '/?token=' +
                                    token
                                "
                                ><v-icon>mdi-download</v-icon>DE</v-btn
                              >&nbsp;
                              <v-btn
                                small
                                rounded
                                target="_blank"
                                :href="
                                  '/confirmation/' +
                                    confirmation.courseId +
                                    '/' +
                                    confirmation.peopleId +
                                    '/it/?token=' +
                                    token
                                "
                                ><v-icon>mdi-download</v-icon>IT</v-btn
                              >
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <td colspan="4">
                            {{ $t("Keine Besätitgungen vorhanden") }}
                          </td>
                        </tbody>
                      </template>
                    </v-simple-table>
                    <div v-else>
                      <template v-if="confirmations && confirmations.length">
                        <v-simple-table 
                          class="my-2"  
                          v-for="(confirmation, index) in confirmations"
                          :key="index"
                        >
                          <template v-slot:default>
                            <tbody>
                              <tr>
                                <th class="text-left" style="width: 20%">
                                  {{ $t("Name") }}
                                </th>
                                <td>{{ confirmation.child_name }}</td>
                              </tr>
                              <tr>
                                <th class="text-left" style="width: 20%">
                                  {{ $t("Kurs") }}
                                </th>
                                <td>{{ confirmation.course_name }}</td>
                              </tr>
                              <tr>
                                <th class="text-left" style="width: 20%">
                                  {{ $t("Wochen") }}
                                </th>
                                <td>{{ confirmation.week_count }}</td>
                              </tr>
                              <tr>
                                <th class="text-left" style="width: 20%"></th>
                                <td>
                                  <v-btn
                                    small
                                    rounded
                                    target="_blank"
                                    :href="
                                      '/confirmation/' +
                                        confirmation.courseId +
                                        '/' +
                                        confirmation.peopleId +
                                        '/?token=' +
                                        token
                                    "
                                    ><v-icon>mdi-download</v-icon>DE</v-btn
                                  >&nbsp;
                                  <v-btn
                                    small
                                    rounded
                                    target="_blank"
                                    :href="
                                      '/confirmation/' +
                                        confirmation.courseId +
                                        '/' +
                                        confirmation.peopleId +
                                        '/it/?token=' +
                                        token
                                    "
                                    ><v-icon>mdi-download</v-icon>IT</v-btn
                                  >
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </template>
                      <v-alert v-else>{{ $t("Keine Besätitgungen vorhanden") }}</v-alert>
                    </div>
                  </v-card-text>
                </v-card>
              </template>

            </v-card-text>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Swal from "sweetalert2";
import {
  fetchConfirmations
} from "./shared/services";
export default {
  name: "app-frontend-confirmations",
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      token: "",
      loading: true,
      confirmations: null,
    };
  },
  mounted() {
    this.token = localStorage.getItem("laravel-vue-spa");
    this.getData();
  },
  methods: {
    getData() {
      if (!this.$auth.user().people) {
        this.loading = false;
        return;
      }
      this.loading = true;
      this.$auth.fetch();
      fetchConfirmations().then(res => {
        this.confirmations = res.confirmations;
        this.loading = false;
      });
    },
    currentColor() {
      return this.$store.state.modules.options.app_color
        ? this.$store.state.modules.options.app_color
        : "primary";
    }
  }
};
</script>
